import { createAction } from '@reduxjs/toolkit';
import { DocumentResourcePayload } from 'data/documents';

export const updateDocResource = createAction<DocumentResourcePayload>(
  'documents/saga/update-resource',
);
